export enum IntegrationStatus {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}
